module.exports = require('./helpers/bundle-url').getBundleURL('23LRb') + "logo-dark.eefe0b7f.svg";